export default __webpack_public_path__ + "static/media/md-my-train.6d1de529.svg";